import layer from '@core/layer'

// 自动添加viewport
if (isMobile()) {
  var $_meta = $('meta'),
    hasViewport = false
  $_meta.each(function(i, $_item) {
    if ($_item.name && $_item.name === 'viewport') {
      hasViewport = true
      return
    }
  })
  if (!hasViewport) {
    $('head').prepend(
      '<meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1">'
    )
  }
}

function isMobile() {
  var userAgentInfo = navigator.userAgent,
    Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')

  var flag = false
  for (var v = 0; v < Agents.length; v += 1) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true
      break
    }
  }
  return flag
}

export default function(options) {
  layer(options)
}
